module.exports = __webpack_public_path__ + "static/img/in.5253c462.png";